import { EReflistChapterName } from 'affiny-core/modules/api/repositories/reflists/reflists.types';
import { match } from 'react-router-dom';

export enum WebRoutes {
  ProfileCapturePrefix = '/screen',
  ProfileCaptureAnnounce = '/screen/standalone/announce',
  ProfileCaptureProfilePicture = '/screen/standalone/picture',
  ProfileCaptureSafetyTips = '/safety-tips',
  ProfileCaptureCrossSellLegalCheck = '/screen/xsell-legal-check',
  RedirectPrefix = '/redirect',
  WhyPremium = '/why-premium',
  RedirectToSpecialOfferFromCRM = '/redirect-to-special-offer',
  RedirectToPaymentFromCRM = '/redirect-to-payment',
  RedirectToVisitsOrProfileDisplayFromCRM = '/redirect-to-visits-or-profile-display/:accountId',
  RedirectToFavoritesOrProfileDisplayFromCRM = '/redirect-to-favorites-or-profile-display/:accountId',
}
// All React Router route params are strings
type TReactRouterMatchParams = Partial<Record<string, string>>;
type TAppMatchParams = Record<
  WebRoutes,
  match<TReactRouterMatchParams>['params']
>;

export interface WebRoutesParams extends TAppMatchParams {
  [WebRoutes.ProfileCapturePrefix]: {
    chapterLabel: EReflistChapterName;
    questionIndex?: string;
  };
  [WebRoutes.RedirectToVisitsOrProfileDisplayFromCRM]: {
    accountId: string;
  };
  [WebRoutes.RedirectToFavoritesOrProfileDisplayFromCRM]: {
    accountId: string;
  };
}
